// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-6-container {
    margin-bottom: 10rem;
}

.bold-heading {
    font-weight: bolder;
}

.expertise-top {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.expertise-top p:nth-child(1) {
    font-size: 3rem;
    margin: 0;
}

.expertise-top p:nth-child(2) {
    font-size: 1.5rem;
}

.expertise-bottom {
    width: 60%;
    display: grid;
    margin: auto;
    justify-items: center;
    gap: 1rem;
    grid-template-columns: repeat(3, 1fr);

    & img {
        width: 100%;
    }
}

@media screen and (min-width:300px) and (max-width:490px) {
    .section-6-container {
        margin-bottom: var(--margin-bottom-mobile);
    }

    .expertise-top p:nth-child(1) {
        font-size: var(--font-size8);
    }

    .expertise-top p:nth-child(2) {
        font-size: 0.75rem;
    }

    .expertise-bottom {
        width: 90%;
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (min-width:601px) and (max-width:840px) {
    .expertise-top p:nth-child(1) {
        font-size: var(--font-size6);
    }

    .expertise-top p:nth-child(2) {
        font-size: 1rem;
    }

    .expertise-bottom {
        width: 80%;
        grid-template-columns: repeat(3, 1fr);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/Section6.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,SAAS;IACT,qCAAqC;;IAErC;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,0CAA0C;IAC9C;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,qCAAqC;IACzC;AACJ","sourcesContent":[".section-6-container {\r\n    margin-bottom: 10rem;\r\n}\r\n\r\n.bold-heading {\r\n    font-weight: bolder;\r\n}\r\n\r\n.expertise-top {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.expertise-top p:nth-child(1) {\r\n    font-size: 3rem;\r\n    margin: 0;\r\n}\r\n\r\n.expertise-top p:nth-child(2) {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.expertise-bottom {\r\n    width: 60%;\r\n    display: grid;\r\n    margin: auto;\r\n    justify-items: center;\r\n    gap: 1rem;\r\n    grid-template-columns: repeat(3, 1fr);\r\n\r\n    & img {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .section-6-container {\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .expertise-top p:nth-child(1) {\r\n        font-size: var(--font-size8);\r\n    }\r\n\r\n    .expertise-top p:nth-child(2) {\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    .expertise-bottom {\r\n        width: 90%;\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n}\r\n\r\n@media screen and (min-width:601px) and (max-width:840px) {\r\n    .expertise-top p:nth-child(1) {\r\n        font-size: var(--font-size6);\r\n    }\r\n\r\n    .expertise-top p:nth-child(2) {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .expertise-bottom {\r\n        width: 80%;\r\n        grid-template-columns: repeat(3, 1fr);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
